<template>
  <div class="main-video">
    <p class="title">용TV</p>

    <div class="match-highlight">
      <div class="empty" v-if="isEmpty(video) || isEmpty(video.youtube_url)">
        데이터가 없습니다
      </div>
      <div class="video-frame" v-else>
        <iframe width="100%" height="315"
                :src="video.youtube_url"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>
<script>
import {isEmpty} from '@/lib';

export default {
  name: 'Video',
  data() {
    return {
      video: {}
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    isEmpty,
    async init() {
      const {data} = await this.$http.get(`/main/movie`);
      if (data.success) {
        this.video = data.data;
      }
    }
  }
}
</script>
<style scoped>
.main-video {
  padding-top: 0;
}
</style>
